import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MineAvatarGQL,
  UpdateMineAvatarGQL,
  UploadContext,
} from '../../../../../../../graphql';
import { Store } from '@ngrx/store';
import { pluck, switchMap, tap } from 'rxjs';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

@Component({
  selector: 'app-avatar-quick-fix',
  templateUrl: './avatar-quick-fix.component.html',
  styleUrls: ['./avatar-quick-fix.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AvatarQuickFixComponent extends AliveState implements OnInit {
  avatar = new UntypedFormControl();
  avatarUploadContext: UploadContext = UploadContext.UserAvatar;

  constructor(
    private store: Store,
    private updateMineAvatarGQL: UpdateMineAvatarGQL,
    private mineAvatarGQL: MineAvatarGQL,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.mineAvatarGQL.fetch({}).pipe(
        pluck('data', 'getMineAvatar', 'file'),
        tap((avatar) => {
          this.avatar.patchValue(avatar);
        }),
      ),
      this.avatar.valueChanges.pipe(
        switchMap((file) => {
          return this.updateMineAvatarGQL.mutate({
            variables: {
              file,
            },
          });
        }),
      ),
    );
  }
}
